import React, {useRef, useState} from "react";
import {useMovementsData} from "../../hooks/useMovementsData";
import {
    getDataFresh, getDepartmentsData, getDriversData,
    getMovementRatesData,
    getMovementsData, getMovementTypesData, getTrackingOptionsData
} from "../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import LoadingSpinner from "../Utils/Spinner";
import { Box, Button, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import CreateMovement from "./CreateMovement";
import axios from "axios";
import {createSetDataFreshAction, createSetMovementsDataAction} from "../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import {movementCost} from "../../utils";
import {useMovementsRateData} from "../../hooks/useMovementsRateData";
import useSelect from "../../hooks/useSelect";
import useInput from "../../hooks/useInput";
import SearchBar from "../Utils/SearchBar";
import {useMovementTypesData} from "../../hooks/useMovementTypesData";
import PrintMovements from "./PrintMovementList";
import {useReactToPrint} from "react-to-print";
import {useDriversData} from "../../hooks/useDriversData";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import PrintGoodsDelivery from "./PrintGoodsDelivery";
import PrintMovementNote from "./PrintMovementNote";
import ReducedMovementRow from "./ReducedMovementRow";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import FigureSummary from "../Figures/FigureSummary";
import Nav from "../Nav/Nav";
import PaginationWrapper from "../Utils/PaginationWrapper";



export default function MovementView(props){
    let [page, setPage] = useState(1);
    const componentRef = useRef();
    const goodsRef = useRef();
    const movementNoteRef = useRef();

    const handlePrint = useReactToPrint({contentRef: componentRef});
    const handleGoodsPrint = useReactToPrint({contentRef: goodsRef});
    const handleNotePrint =  useReactToPrint({contentRef:  movementNoteRef});

    const [searchText, setSearchText] = useState()
    const [currentSearch, setCurrentSearch] = useState();
    const [selectedDepartment, setSelectedDepartment] = useState("BLANK");

    let params = {page: page}
    let dataFresh = useSelector(getDataFresh);
    const [selected, setSelected] = useState({});
    const [filters, setFilters] = useState({});
    const [createModalOpen, setCreateModalOpen] = useState(false);

    const headings = [
        {
            label: "Movement No.",
            show: true
        },
        {
            label: "Supplier",
            show: true
        },
        {
            label: "Vehicle to Move",
            show: true
        },
        {
            label: "Start Address",
            show: true
        },
        {
            label: "End Address",
            show: true
        },
        {
            label: "Delivery Date",
            show: true
        },
        {
            label: "Start Time",
            show: true
        },
        {
            label: "End Time",
            show: true
        },
        // {
        //     label: "Supplier Charge",
        //     show: true
        // },
        // {
        //     label: "Cost Override",
        //     show: true
        // },
        {
            label: "Vehicle Used",
            show: true
        },
        {
            label: "Internal Comments",
            show: true
        },
        {
            label: "Job Comments",
            show: true
        },
        {
            label: "Driver",
            show: true,
            field: "driver",
            labelField: "driver__name"
        },
        {
            label: "Driver Job Number",
            show: true
        },
        {
            label: "Work Complete",
            show: true
        }
    ]


    const options = [
        {name: "Normal", value: "NORMAL"},
        {name: "Quote", value: "QUOTE"},
        {name: "Work Complete", value: "WORKCOMPLETE"},
        {name: "Approved", value: "COMPLETED"}
    ];

    const onSelectCheck = item => {
        let newSelection = { ...selected };
        if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
          newSelection[item.id.toString()] = item;
        } else {
          delete newSelection[item.id.toString()];
        }
        setSelected(newSelection);
    };

    const toggleSelectVisible = () => {
        let newSelected = { ...selected };
        let selectedKeys = Object.keys(newSelected);
        const notPresent = data.results.find(
          movement => selectedKeys.indexOf(movement.id.toString()) === -1
        );

        if (notPresent) {
          data.results.forEach(item => {
            newSelected[item.id.toString()] = item;
          });
        } else {
          data.results.forEach(item => {
            delete newSelected[item.id.toString()];
          });
        }
        setSelected(newSelected);
    };

    const clearSelected = () => {
        setSelected({});
    };

    const [statusOption, statusOptionsInput] = useSelect({
        label: "Status",
        initialValue: "NORMAL",
        options: options,
        callback: () => {
            clearSelected();
            setPage(1);
        }
    });
    const [startDate, startDateInput] = useInput({
        type: "date",
        label: "Start Date",
    })
    const [endDate, endDateInput] = useInput({
        type: "date",
        label: "End Date",
    })
    if(startDate){
        params.start = startDate
    }
    if(endDate){
        params.end = endDate
    }
    if (currentSearch) {
        params.search = currentSearch;
    }
    if(statusOption){
        params.view = statusOption
    }
    if(selectedDepartment){
        params.department=selectedDepartment;
    }
    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }
    const [movementRateParams, setMovementRateParams] = useState({page_size: 1000})

    let loaded = useMovementsData(params, dataFresh);
    let movementRateLoaded = useMovementsRateData(movementRateParams, dataFresh);
    let movementTypeLoaded = useMovementTypesData({}, dataFresh);
    let departmentsLoaded = useDepartmentsData({}, dataFresh);
    let driversLoaded = useDriversData({}, dataFresh);
    let trackingOptionsLoaded = useTrackingOptionsData({}, dataFresh);

    let data = useSelector(getMovementsData);
    let rateData = useSelector(getMovementRatesData);
    let typeData = useSelector(getMovementTypesData);
    let drivers = useSelector(getDriversData);
    let departments = useSelector(getDepartmentsData);
    let trackingOptions = useSelector(getTrackingOptionsData);
    const dispatch = useDispatch();

    const onChange = (e, index) => {
        let newResults = [...data.results];
        let newData  =  {...data, results: newResults}
        let newMovement = {...data.results[index], [e.target.name]: e.target.value}
        newMovement = movementCost(newMovement);
        newData.results[index] = newMovement
        dispatch(createSetMovementsDataAction(newData))
    }
    const onRateChange = (e, index) => {
        let toUpdate ={
            target: {
                name: e.target.name,
                value: movementRateObjects[e.target.value]
            }
        }
        onChange(toUpdate, index);
    };

    const onCheck = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        }
        onChange(toUpdate, index)
    }

    const onDriverChange = (e, index) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: driverObjects[e.target.value]
            }
        }
        onChange(toUpdate, index)
    }



    const onQuoteToMovement = (data) => {
        const url = props.endpoint+"movementquote/"+data.id;
        const conf = {
            url: url,
            method: "put"
        }
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    };

    const onSave = (data) => {
        const conf = {
            url: props.endpoint+"movement/"+data.id,
            method: "put",
            data: data
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            clearSelected();
        }).catch(()=> {
            toast.error("There was an error saving the movement", {position: "top-right"})
        })
    };

    const handleSearch = () => {
        setPage(1);
        setCurrentSearch(searchText);
    };

    const clear = () => {
        setSearchText("");
        setCurrentSearch("");
        setPage(1);
    };


    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value);
    }

    if(!loaded || !movementRateLoaded || !movementTypeLoaded || !driversLoaded || !departmentsLoaded || !trackingOptionsLoaded){
        return (
            <div>
                <Nav/>
                <LoadingSpinner/>
            </div>
        )
    }

    const movementRateObjects = rateData ? rateData.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {results: []};

    const departmentObjects = departments ? departments.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {results: []};

    const movementTypeObjects = typeData ? typeData.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}): {results: []};

    const driverObjects = drivers ? drivers.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}): {results: []};

    const trackingOptionObjects = trackingOptions ? trackingOptions.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}): {results: []};
    document.title="Movements";
    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <Nav/>
            <br/>
            <br/>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Column>
                            <Title>Movements</Title>
                        </Column>
                    </Column>
                    <Column>
                        <Button
                            color={"success"}
                            onClick={() => {
                                setCreateModalOpen(true)
                            }}
                        >
                            Create Movement +
                        </Button>
                    </Column>
                    <Column>
                        <Button
                          color={"warning"}
                          onClick={handleGoodsPrint}
                        >
                          Print Blank Goods Delivery
                        </Button>
                    </Column>
                    <Column>
                        <Button
                          color={"warning"}
                          onClick={handleNotePrint}
                        >
                          Print Blank Movement Note
                        </Button>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        {statusOptionsInput}
                    </Column>
                    <Column>
                        <DepartmentSelector
                            value={selectedDepartment}
                            onChange={onDepartmentChange}
                            options={departments}
                            editable={true}
                            name={"department"}
                            label={"Department"}
                            blank={true}
                        />
                    </Column>
                    <Column>
                        <label className="label">Search</label>
                        <SearchBar
                            handleSearch={handleSearch}
                            setSearchText={setSearchText}
                            searchText={searchText}
                            clear={clear}
                        />
                    </Column>
                    {startDateInput}
                    {endDateInput}
                    <Column></Column>
                </Columns>
            </Box>
            <FigureSummary selectedDepartment={selectedDepartment}/>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth>
                            <thead>
                            <tr>
                                {headings.map(heading => {
                                    if (!heading.field && heading.show) {
                                      return <th key={heading.label}>{heading.label}</th>;
                                    }
                                    if (heading.blank) {
                                      return (
                                        <FilterBlankHeading
                                          key={heading.label}
                                          heading={heading}
                                          setFilters={f => {
                                            setPage(1);
                                            setFilters(f);
                                          }}
                                          filters={filters}
                                        />
                                      );
                                    }
                                    if(heading.show) {
                                        return (
                                            <FilterHeading
                                                key={heading.label}
                                                heading={heading}
                                                setFilters={f => {
                                                    setPage(1);
                                                    setFilters(f);
                                                }}
                                                filters={filters}
                                                options={data.filter_list[heading.field]}
                                            />
                                        );
                                    }
                                  })}
                                {statusOption === "QUOTE" && <th></th>}
                                {statusOption !== "QUOTE" &&
                                    <th>
                                    <Button
                                        onClick={toggleSelectVisible}
                                        color={
                                            data.results.find(movement => Object.keys(selected).indexOf(movement.id.toString()) === -1) ? "" : "danger"
                                        }
                                    >
                                        {data.results.find(movement => Object.keys(selected).indexOf(movement.id.toString()) === -1) ?
                                            (
                                            <div>
                                                O
                                                <span>Visible</span>
                                            </div>
                                        ) : (
                                            <div>
                                                X
                                                <span>Visible</span>
                                            </div>
                                        )}
                                    </Button>
                                    </th>
                                }
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {/*{data.results.map(((movement, index) => (*/}
                            {/*    <MovementRow*/}
                            {/*        movement={movement}*/}
                            {/*        onDelete={onDelete}*/}
                            {/*        onChange={onChange}*/}
                            {/*        index={index}*/}
                            {/*        onSave={onSave}*/}
                            {/*        rateOptions={rateData}*/}
                            {/*        onRateChange={onRateChange}*/}
                            {/*        view={statusOption}*/}
                            {/*        quoteToMovement={onQuoteToMovement}*/}
                            {/*        onComplete={onAttemptComplete}*/}
                            {/*        movementTypes={typeData}*/}
                            {/*        movementTypeObjects={movementTypeObjects}*/}
                            {/*        endpoint={props.endpoint}*/}
                            {/*        disabled={movement.completed}*/}
                            {/*        onSelectCheck={onSelectCheck}*/}
                            {/*        selected={Object.keys(selected).indexOf(movement.id.toString()) !== -1}*/}
                            {/*        isJob={false}*/}
                            {/*        driverObjects={driverObjects}*/}
                            {/*        driverOptions={drivers}*/}
                            {/*        departments={departments}*/}
                            {/*        departmentObjects={departmentObjects}*/}
                            {/*    />*/}
                            {/*)))}*/}
                            {data.results.map((movement, index) => (
                                <ReducedMovementRow
                                    data={movement}
                                    index={index}
                                    onChange={onChange}
                                    onSave={onSave}
                                    onSelectCheck={onSelectCheck}
                                    selected={Object.keys(selected).indexOf(movement.id.toString()) !== -1}
                                    endpoint={props.endpoint}
                                    onCheck={onCheck}
                                    drivers={drivers}
                                    onDriverChange={onDriverChange}
                                    view={statusOption}
                                    quoteToMovement={onQuoteToMovement}
                                />
                            ))}
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
                <PaginationWrapper
                    setPage={setPage}
                    page={page}
                    dataCount={Math.ceil(data.count / 25)}
                ></PaginationWrapper>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Button
                          color={Object.entries(selected).length ? "success" : "warning"}
                          disabled={Object.entries(selected).length < 1}
                          onClick={handlePrint}
                          isFullWidth
                        >
                          Print Selected
                        </Button>
                    </Column>
                </Columns>
            </Box>
            <CreateMovement
                open={createModalOpen}
                setOpen={setCreateModalOpen}
                endpoint={props.endpoint}
                dataFresh={dataFresh}
                movementRateOptions={rateData}
                movementRateObjects={movementRateObjects}
                movementTypeObjects={movementTypeObjects}
                movementTypeOptions={typeData}
                driverObjects={driverObjects}
                driverOptions={drivers}
                departments={departments}
                departmentObjects={departmentObjects}
                movementRateParams={movementRateParams}
                setMovementRateParams={setMovementRateParams}
            />
            <div style={{display: "none"}}>
                <div  ref={componentRef}>
                    <PrintMovements data={selected}/>
                </div>
                <div ref={goodsRef}>
                    <PrintGoodsDelivery/>
                </div>
                <div ref={movementNoteRef}>
                    <PrintMovementNote/>
                </div>
            </div>
        </div>
    );
}